import { isSafeHttpUrl } from '../../utils/url'
import { useSearchQueryParams } from '../useSearchParams'

// With airline ticket.
// Sidepanel's airline ticket should add check-in, check-out,
// adults, children, infants and rooms to query params
export const useAirlineTicketUrl = (withAirlineTicketUrl?: string | null) => {
  const { params } = useSearchQueryParams()
  const {
    checkInDate,
    checkOutDate,
    numberOfAdults,
    numberOfChildren,
    numberOfInfants,
    roomCount,
    areas,
  } = params

  if (!isSafeHttpUrl(withAirlineTicketUrl)) {
    // The URL is set per property by the hotel operator, so a value that is
    // not http(s) (e.g. javascript:) must never reach window.open.
    return undefined
  }

  const searchParams = new URLSearchParams()
  searchParams.set('check_in', checkInDate)
  searchParams.set('check_out', checkOutDate)
  searchParams.set('adults', numberOfAdults ? numberOfAdults.toString() : '2')
  searchParams.set(
    'children',
    numberOfChildren ? numberOfChildren.toString() : '0'
  )
  searchParams.set(
    'infants',
    numberOfInfants ? numberOfInfants.toString() : '0'
  )
  searchParams.set('rooms', roomCount ? roomCount.toString() : '1')
  areas.forEach((area) => searchParams.append('area', area))

  return `${withAirlineTicketUrl}?${searchParams.toString()}`
}
